if (!customElements.get('size-guide-drawer')) {
  class SizeGuideDrawer extends HTMLElement {
    constructor() {
      super();
      this.triggers = [];
      this.drawer = null;
      this.closeButton = null;
      this.observer = null;
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
    }

    connectedCallback() {
      this.drawer = this.querySelector('theme-drawer');
      this.closeButton = this.drawer?.querySelector('[data-size-guide-close]');
      if (!this.drawer) return;

      this.triggers = [
        ...(this.parentElement?.querySelectorAll(`[data-size-guide-trigger][aria-controls="${this.drawer.id}"]`) ?? []),
      ];

      if (this.drawer.parentElement !== document.body) {
        document.body.appendChild(this.drawer);
      }

      this.triggers.forEach(trigger => trigger.addEventListener('click', this.handleTriggerClick));
      this.closeButton?.addEventListener('click', this.handleCloseClick);

      this.observer = new MutationObserver(() => this._syncExpanded());
      this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['data-open'] });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.triggers.forEach(trigger => trigger.removeEventListener('click', this.handleTriggerClick));
      this.closeButton?.removeEventListener('click', this.handleCloseClick);
      this.drawer?.remove();
      this.triggers = [];
      this.drawer = null;
      this.closeButton = null;
    }

    handleTriggerClick(event) {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      this.drawer.open();
      this.closeButton?.focus({ preventScroll: true });
    }

    handleCloseClick() {
      this.drawer.close();
    }

    _syncExpanded() {
      const isOpen = String(this.drawer.hasAttribute('data-open'));
      this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', isOpen));
    }
  }

  customElements.define('size-guide-drawer', SizeGuideDrawer);
}
